import { render } from "./SelectPaymentView.vue?vue&type=template&id=6ed69c6d&scoped=true&ts=true"
import script from "./SelectPaymentView.vue?vue&type=script&lang=ts"
export * from "./SelectPaymentView.vue?vue&type=script&lang=ts"

import "./SelectPaymentView.vue?vue&type=style&index=0&id=6ed69c6d&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed69c6d"]])

export default __exports__